module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "new-custom-fields-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v(_vm._s(_vm.title_modal)), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    attrs: {
      "id": "custom-field-form"
    }
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('field')
    }
  }, [_c('label', {
    attrs: {
      "for": "field"
    }
  }, [_vm._v("Nome do campo")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_field.field),
      expression: "custom_field.field"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "custom-field-name",
      "name": "field",
      "type": "text"
    },
    domProps: {
      "value": (_vm.custom_field.field)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.custom_field, "field", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('field')),
      expression: "errors.has('field')"
    }],
    key: "field",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('field')))])])], 1), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('kind')
    }
  }, [_c('label', [_vm._v("Selecione o tipo de propriedade")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_field.kind),
      expression: "custom_field.kind"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control select-kind",
    class: _vm.custom_field.kind,
    attrs: {
      "disabled": _vm.custom_field.id,
      "name": "kind"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.custom_field, "kind", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.kinds), function(kind) {
    return _c('option', {
      domProps: {
        "value": kind.value
      }
    }, [_vm._v(_vm._s(kind.label))])
  }), 0), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('kind')),
      expression: "errors.has('kind')"
    }],
    key: "kind",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('kind')))])])], 1), (_vm.custom_field.kind == 'dropdown') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Opções da Múltipla Escolha")]), _c('draggable', {
    attrs: {
      "value": _vm.custom_field.options,
      "options": _vm.draggable_options
    },
    on: {
      "input": _vm.priorityUpdated
    }
  }, _vm._l((_vm.custom_field.options), function(option, index) {
    return _c('div', {
      staticClass: "option"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.name),
        expression: "option.name"
      }],
      staticClass: "form-control",
      class: {
        'deleted': option.deleted
      },
      attrs: {
        "disabled": option.deleted,
        "placeholder": 'Opção ' + (index + 1)
      },
      domProps: {
        "value": (option.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(option, "name", $event.target.value)
        }
      }
    }), _c('button', {
      staticClass: "close",
      attrs: {
        "type": "button",
        "aria-label": "Close",
        "disabled": option.deleted
      },
      on: {
        "click": function($event) {
          return _vm.remove(option)
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])])])
  }), 0), _c('div', {
    staticClass: "add-option",
    on: {
      "click": _vm.addOption
    }
  }, [_c('span', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("+ ")]), _c('span', {
    staticClass: "text"
  }, [_vm._v("Adicionar Opção")])])], 1) : _vm._e(), (_vm.option_deleted) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._v("A deletar o campo, você deve selecionar uma das opções abaixo:"), _c('div', [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": _vm.checkboxDontReplace
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.dont_replace
    }
  }), _c('label', [_vm._v("Não substituir essa informação no contato.")])])]), _c('div', [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": _vm.checkboxReplaceOption
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.replace_option
    }
  }), _c('label', [_vm._v("Substituir pela informação:")])])])]) : _vm._e(), (_vm.replace_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_value),
      expression: "new_value"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "new_value"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.new_value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.valid_options), function(option) {
    return _c('option', {
      domProps: {
        "value": option.name
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)]) : _vm._e()])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-gray",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancelar")]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.label_button))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22bfcaaa!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/custom_fields/new_modal.vue
// module id = 1044
// module chunks = 1